import { Box, Grid, IconButton, OutlinedInput, Typography } from "@mui/material";
import { BackButton, BackgroundStyle, BigHeading, FlexContainer, LightBlueContainer, ListContainer, SearchingBoxContainer, LongBlueButton, ShortBlueButton, BarContainer, WhiteContainer, LabelContainer, DocumentButton, ButtonContainer, StyledLink, WorkDetailContainer } from "../assets/style";
import RecordTable, { TableRow, TableHeader } from "../components/RecordTable";
import { MouseEventHandler, useEffect, useRef, useState } from "react";
import SearchInput from "../components/SearchInput";
import SearchDatePicker from "../components/SearchDatePicker";
import dayjs from 'dayjs';
import SearchBox from "../components/SearchBox";
import ProjectBar from "../components/ProjectBar";
import FormButton from "../components/FormButton";
import FormLabel from "../components/FormLabel";
import axios from "axios";
import { deleteIcon } from "../assets/imgs";
import FormLongLabel from "../components/FormLongLabel";
import { useLocation, useNavigate } from "react-router-dom";
import MainContent from '../components/MainContent';
import BigMapCard from '../components/MapBigCard'
import MapCard from "../components/MapBigCard";
import { entryPageName, reportPageName } from "../components/PageName";
import { useLazyGetScheduleByIdQuery, useLazyGetScheduleByScheduleIdQuery, useLazyGetWorkScheduleFileQuery } from "../features/schedule/scheduleSlice";
import { useLazyGetProjectByIdQuery } from "../features/project/projectSlice";
import { useTranslation } from "react-i18next";

const ReportingDetailPage = () => {
    const {t, i18n} = useTranslation();
    const getLocation = useLocation();
    const entry = getLocation.state?.entry;
    const project = getLocation.state?.project;
    const location = getLocation.state?.location;
    // const editEntry = true;
    // console.log("entry", entry)
    // const [projectNum, setProjectNum] = useState("");
    // const [date, setDate] = useState(dayjs());
    // const [projectName, setProjectName] = useState("");
    const [riskAssessment, setRiskAssessment] = useState<File | null>(null);
    const [workPermit, setWorkPermit] = useState<File | null>(null);
    // const workPermitFileInputRef = useRef<HTMLInputElement>(null);
    // const riskAssessmentFileInputRef = useRef<HTMLInputElement>(null);

    const [getScheduleQuery, scheduleData] = useLazyGetScheduleByScheduleIdQuery();
    const [getProjectQuery, projectData] = useLazyGetProjectByIdQuery();
    const [getWorkScheduleFile] = useLazyGetWorkScheduleFileQuery();

    const navigate = useNavigate()
    useEffect(() => {
        handleProjectData(entry?.id)
    }, [])

    function getFileNameFromUrl(url: any) {
        console.log("Get File Name ")
        const parts = url.split('/');
        return parts[parts.length - 1];
    }

    const [selectPosition, setTemp] = useState(
        {
            project_id: 1,
            project_name: "Vision Peak Solutions company",
            place_id: 1,
            name: 'testing name',
            lat: 22.32538,
            lng: 114.18028,
            detail: 'location 1 detail',
            date: "18/01/2024",
            on_site_day: 5,
            code: "testing code"
        });

    useEffect(() => {
        // setRiskAssessment(scheduleData?.data?.siteDocements[0])
        // setWorkPermit(scheduleData?.data?.siteDocements[1])
        // console.log("project", project)


        if (scheduleData?.data?.siteDocements[0]?.type == 'ra') {
            setRiskAssessment(scheduleData?.data?.siteDocements[0])
        } else if (scheduleData?.data?.siteDocements[1]?.type == 'ra') {
            setRiskAssessment(scheduleData?.data?.siteDocements[1])
        }

        if (scheduleData?.data?.siteDocements[0]?.type == 'wp') {
            setWorkPermit(scheduleData?.data?.siteDocements[0])
        } else if (scheduleData?.data?.siteDocements[1]?.type == 'wp') {
            setWorkPermit(scheduleData?.data?.siteDocements[1])
        }
    }, [getScheduleQuery, scheduleData])

    const handleProjectData = async (curWorkerStataus: any) => {
        try {
            if (localStorage.accessToken && entry?.id) {

                getScheduleQuery({
                    id: entry?.id
                })
                    .then((schedule: any) => {
                        if (schedule.status == 'fulfilled') {
                            console.log("getScheduleQuery", schedule?.data)
                        }
                    })

                getProjectQuery(
                    project
                )
                    .then((project: any) => {
                        if (project.status == 'fulfilled') {
                            console.log("getProjectQuery", project?.data)
                        }
                    })
            }
        }
        catch (error) {
            alert('An error occurred. Please refresh (F5) or login again.');
            console.log(error);
        } finally {
            // console.log("workerStates", workerStates)
        }
    };

    const EquipmentColumns: TableHeader[] = [
        { field: 'equipmentTypeId', headerName: t('Type'), width: 200, isSortable: true },
        { field: 'rfidNumber', headerName: t('RFID No.'), width: 200, isSortable: false },
        { field: 'equipmentNumber', headerName: t('Equipment No.'), width: 200, isSortable: false },
        { field: 'equipmentName', headerName: t('Equipment Name'), width: 200, isSortable: false },
        { field: 'manufacturer', headerName: t('Brand / Manufacturer'), width: 300, isSortable: true },
        { field: 'modelNumber', headerName: t('Model No.'), width: 200, isSortable: false },
        // { field: 'purchaseDate', headerName: 'Purchase Date', width: 300, isSortable: false },
        // { field: 'expiryDate', headerName: 'Expiry Date', width: 300, isSortable: false },
        // { field: 'certDueDate', headerName: 'Next Cal. / Cert Due Date', width: 200, isSortable: false },
        // { field: 'calPeriod', headerName: 'Cal. Period', width: 200, isSortable: false },
        // { field: 'certification', headerName: 'Certification', width: 200, isSortable: false },
        // { field: 'qrCode', headerName: 'QR Code', width: 200, isSortable: false },
    ];

    // const getLink = function (file: File | null | undefined) {
    //     if (file) {
    //         return <a
    //             onClick={() => { displayImageInNewTab(file, file.name) }}
    //             style={{ marginLeft: "10px" }}
    //             href={"javascript:;"}
    //             target="_blank"
    //             rel="noopener noreferrer"
    //         >
    //             {file.name}
    //         </a>
    //     } else {
    //         return ""
    //     }
    // }
    const getLink = function (file: any) {
        console.log("file", file)
        if (file) {
            console.log("getLink", file.name)
            return <a
                onClick={async () => { await getFile(file.id, file.name, file.contentType) }}
                href={"javascript:;"}
                target="_self"
                rel="noopener noreferrer"
            >
                {file.name}
            </a>
        } else {
            return "None"
        }
    }
    const getFile = async function (id: string, name: string, type: string) {
        try {
            const dataUrl = await getWorkScheduleFile(id).unwrap()
            const blob = await fetch(dataUrl).then(r => r.blob());
            const file = new File([blob], name, { type: type });
            displayImageInNewTab(file, name)
        } catch (error) {
            alert("fails to open the file.")
            console.error(error)
            // navigate('/worker-detail', { state: { workerID: workerId } })
        } finally {

        }
    }

    const displayImageInNewTab = function (blob: Blob, filename: string) {
        const imageUrl = URL.createObjectURL(blob);
        const newTab = window.open(imageUrl);
    }

    const displayEquipments = function () {
        var workerCount = scheduleData?.data?.workers.filter((x: any) => x.typeId === 3).length;
        for (var i = 0; i < workerCount; i++) {

        }
    }

    return (
        // <MainContent>
        <MainContent type={reportPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer className="data-table-overide-styles">
                    <BigHeading>{t("Report Detail")}</BigHeading>
                    <SearchingBoxContainer>

                        <Grid container spacing={1.5} >
                            <Grid item xs={12} sm={7}>
                                <WorkDetailContainer >
                                    <Box >
                                        {/* <ProjectBar /> */}
                                        <ProjectBar
                                            newEntry={false}
                                            user={scheduleData?.data?.createdBy}
                                            updatedOn={scheduleData?.data?.updatedOn}
                                            // updatedOn={updateTime?.format("DD/MM/YYYY HH:mm:ss")}
                                            updatedBy={scheduleData?.data?.updatedBy}
                                        />
                                    </Box>
                                    <Box >
                                        <WhiteContainer sx={{ height: '100%', minHeight: "530px" }}>
                                            {/* <Box sx={{ margin: '20px' }}>
                                                Map Card<br />

                                            </Box> */}
                                            {/* <BigMapCard selectPosition={selectPosition} isInput={false} /> */}
                                            <BigMapCard
                                                // selectPosition={entryData?.position}
                                                selectPosition={selectPosition}
                                                isInput={false}
                                                startTime={scheduleData?.data?.startTime}
                                                endTime={scheduleData?.data?.endTime}
                                                date={scheduleData?.data?.workDate}
                                                // setDate={setDate}
                                                project={projectData?.data}
                                                schedule={entry}
                                            />
                                        </WhiteContainer>
                                    </Box>
                                </WorkDetailContainer>
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <WorkDetailContainer>
                                    <Box >
                                        <WhiteContainer sx={{ height: '100%', minHeight: "190px" }}>
                                            <Box>
                                                <BigHeading>Document</BigHeading>
                                                <Box sx={{ m: '10px' }}>
                                                    {/* <FormButton title={"Risk Assessment"} value={riskAssessment} setMethod={uploadRiskAssessment} buttonName={"Select File"} onClick={getFileNameFromUrl} /> */}
                                                    <ButtonContainer>
                                                        <LabelContainer>
                                                            {"Risk Assessment: "}
                                                        </LabelContainer>
                                                        {/* <input type="file" ref={riskAssessmentFileInputRef} onChange={handleRiskAssessmentFileChange} accept="image/*" style={{ display: 'none' }} />
                                                        <DocumentButton onClick={handleRiskAssessmentButtonClick}>Select File</DocumentButton> */}
                                                        {/* {riskAssessment && <a style={{ marginLeft: "10px" }} href={riskAssessment} target="_blank" rel="noopener noreferrer">{getFileNameFromUrl(riskAssessment)}</a>} */}
                                                        {riskAssessment && getLink(riskAssessment)}
                                                        {/* {riskAssessment &&
                                                            <IconButton onClick={() => setRiskAssessment(null)}>
                                                                <img src={deleteIcon} />
                                                            </IconButton>
                                                        } */}
                                                    </ButtonContainer>
                                                    <ButtonContainer>
                                                        <LabelContainer>
                                                            {"Work Permit: "}
                                                        </LabelContainer>
                                                        {/* <input type="file" ref={workPermitFileInputRef} onChange={handleWorkPermitFileChange} accept="image/*" style={{ display: 'none' }} />
                                                        <DocumentButton onClick={handleWorkPermitButtonClick}>Select File</DocumentButton> */}
                                                        {/* {workPermit && <StyledLink href={workPermit} target="_blank" rel="noopener noreferrer">{getFileNameFromUrl(workPermit)}</StyledLink>} */}
                                                        {workPermit && getLink(workPermit)}
                                                        {/* {workPermit &&
                                                            <IconButton onClick={() => setWorkPermit(null)}>
                                                                <img src={deleteIcon} />
                                                            </IconButton>
                                                        } */}
                                                    </ButtonContainer>
                                                </Box>
                                            </Box>
                                        </WhiteContainer>
                                    </Box>
                                    <Box >
                                        <WhiteContainer sx={{ height: '100%', minHeight: "260px", mt: '20px' }}>
                                            <Box>
                                                <BigHeading>On Site Worker</BigHeading>
                                                <Box sx={{ m: '10px' }}>
                                                    <FormLongLabel title={"Competent person"} content={scheduleData?.data?.workers.find((worker: any) => worker.typeId === 1)?.name} />
                                                    <FormLongLabel title={"Standby Person"} content={scheduleData?.data?.workers.find((x: any) => x.typeId === 2)?.name} />

                                                    {scheduleData?.data?.workers
                                                        .filter((x: any) => x.typeId === 3)
                                                        .map((worker: any, index: number) => (
                                                            <FormLongLabel
                                                                key={index}
                                                                title={`Personnel Entering - Worker ${index + 1}`}
                                                                content={worker.name}
                                                            />
                                                        ))
                                                    }
                                                </Box>
                                                {/* <ShortBlueButton onClick={() => navigate(`/add-work-schedule`, { state: { entry, editEntry } })}>Edit Worker</ShortBlueButton> */}
                                            </Box>
                                        </WhiteContainer>
                                    </Box>
                                </WorkDetailContainer>
                            </Grid>
                        </Grid>
                    </SearchingBoxContainer>
                    <BigHeading>On Site Equipment</BigHeading>
                    <RecordTable columns={EquipmentColumns} rows={scheduleData?.data?.siteEquipments} checkbox={false} ></RecordTable>
                    {/* {
                        scheduleData?.data?.siteEquipments.length > 0
                        && <RecordTable columns={EquipmentColumns} rows={scheduleData?.data?.siteEquipments} checkbox={false} ></RecordTable>
                    }

                    {
                        scheduleData?.data?.siteEquipments.length == 0
                        && <Typography style={{ fontSize: 16, marginLeft: 28 }} >
                            No On Site Equipment
                        </Typography>
                    } */}

                    {scheduleData?.data?.workers
                        .filter((x: any) => x.typeId === 3)
                        .map((worker: any, index: number) => (
                            <>
                                <BigHeading>Certified Worker {index + 1}</BigHeading>
                                <RecordTable columns={EquipmentColumns} rows={worker?.equipments} checkbox={false} ></RecordTable>
                                {/* color="#8BB0DB" */}
                            </>
                        ))
                    }
                    <Box sx={{ display: "row" }}>
                        {/* <ShortBlueButton onClick={() => navigate(`/real-time`, { state: { entry } })}>Check in</ShortBlueButton> */}
                        <BackButton onClick={() => navigate(`/entry`)}>{t("Back")}</BackButton>
                    </Box>
                </ListContainer>
            </BackgroundStyle >
            {/* // </MainContent > */}
        </MainContent>
    );
};
export default ReportingDetailPage;